
                import Dic from 'services/dictionary';
                Dic.addWord('wt_all__notification__common_error', {"en":"An error occured, please try again","ru":"Произошла ошибка, попробуйте повторить"});
            